import React from 'react';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';

import { Style } from './style';

export default function Loading() {
  return (
    <Box style={Style}>
      <CircularProgress size={50} />
    </Box>
  );
}
